import { Route } from 'vue-router';

import { TypedObject } from '@/definitions';

const APP_TITLE: string = require('@/../package.json').title;
const META_IDENTIFIER: string = 'data-vue-router-controlled';

const removeMeta = (el: Element) => {
  if (el.parentNode) el.parentNode.removeChild(el);
};

const parseTags = (definition: TypedObject) => {
  const tag: HTMLMetaElement = document.createElement('meta');

  Object.keys(definition).forEach(key => {
    tag.setAttribute(key, definition[key]);
  });

  // Added to sort our meta tags from other ones
  tag.setAttribute(META_IDENTIFIER, '');

  return tag;
}

const metaHook = (to: Route, from: Route, next: Function) => {
  // Look upwards through the tree for a route with a title
  const nearestTitleRoute = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

    // Set page title
    if (nearestTitleRoute) {
      document.title = `${APP_TITLE} • ${nearestTitleRoute.meta.title}`;
    }

  const nearestMetaRoute = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);

  // Remove any meta tags set by us before
  const metaNodes = document.querySelectorAll(`[${META_IDENTIFIER}]`);
  Array.from(metaNodes).map(removeMeta);

  // Skip rendering meta tags if there are none
  if (!nearestMetaRoute) {
    return next();
  }

  // Turn the meta tag definitions in the routes into <HEAD>-elements
  nearestMetaRoute.meta.metaTags
    .map(parseTags)
    .forEach((tag: HTMLMetaElement) => document.head.appendChild(tag));

  next();
};

export default metaHook;